import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Profile from "../views/Profile.vue";
import ProfileStaff from "../views/ProfileStaff.vue";
import Product from "../views/Product.vue";
import News from "../views/News.vue";
import NewsRead from "../views/NewsRead.vue";
import Offer from "../views/Offer.vue";
import Contact from "../views/Contact.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "河南嗨浪技术有限公司"
    }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      title: "公司概况"
    }
  },
  {
    path: "/profile/staff",
    name: "ProfileStaff",
    component: ProfileStaff,
    meta: {
      title: "公司概况"
    }
  },
  {
    path: "/product",
    name: "Product",
    component: Product,
    meta: {
      title: "嗨浪产品"
    }
  },
  {
    path: "/news",
    name: "News",
    component: News,
    meta: {
      title: "新闻中心"
    }
  },
  {
    path: "/news/:id",
    name: "NewsRead",
    component: NewsRead,
    meta: {
      title: "新闻中心"
    }
  },
  {
    path: "/offer",
    name: "Offer",
    component: Offer,
    meta: {
      title: "招商加盟"
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: {
      title: "联系我们"
    }
  }
];

const router = new VueRouter({
  mode: "hash",
  linkActiveClass: "active",
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
